import { render, staticRenderFns } from "./khachhang.vue?vue&type=template&id=0aee3a60&"
import script from "./khachhang.vue?vue&type=script&lang=js&"
export * from "./khachhang.vue?vue&type=script&lang=js&"
import style0 from "./khachhang.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports